"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AiSearchBox = void 0;
var _react = _interopRequireWildcard(require("react"));
var _textEntry = _interopRequireDefault(require("@ux/text-entry"));
var _button = _interopRequireDefault(require("@ux/button"));
var _wand = _interopRequireDefault(require("@ux/icon/wand"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _classnames = _interopRequireDefault(require("classnames"));
var _reactMintl = require("@godaddy/react-mintl");
var _uxUtils = require("@site/ux-utils");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const AiSearchBox = ({
  icon = /*#__PURE__*/_react.default.createElement(_wand.default, null),
  placeholder = '',
  onChange,
  roundedBottomBorder = false,
  onSubmit,
  value = '',
  hintsConfig = {},
  stickySearchBox = false,
  aiSearchBoxButtonClassName
}) => {
  const textEntryId = 'search-box-input';
  const elementRef = (0, _react.useRef)(null);
  const {
    formatMessage
  } = (0, _reactMintl.useIntl)();
  const [size, setSize] = (0, _react.useState)(1);
  const [isHintsVisible, setIsHintsVisible] = (0, _react.useState)(false);
  const isHintsEnabled = Object.keys(hintsConfig).length !== 0 && hintsConfig?.phrases?.length !== 0;
  const prevIsHintsEnabled = (0, _uxUtils.usePrevious)(isHintsEnabled);
  const placeholderIntl = placeholder ? formatMessage({
    id: placeholder
  }) : '';
  const hintsConfigIntl = {
    ...hintsConfig,
    phrases: hintsConfig?.phrases?.map(phrase => formatMessage({
      id: phrase
    }))
  };
  const {
    runHints,
    hideHints
  } = (0, _uxUtils.usePlaceholderHints)({
    hintsConfig: hintsConfigIntl,
    id: textEntryId
  });
  const handleKeyDown = e => {
    if (e.key === 'Enter' && !e.shiftKey) {
      onSubmit(e);
    }
  };
  const calculateBoxHeight = () => {
    elementRef.current.style.height = '0px';
    const scrollHeight = elementRef.current.scrollHeight || 24;
    const calculatedSize = scrollHeight / 24;
    elementRef.current.style.height = `${scrollHeight}px`;
    return Math.floor(calculatedSize >= 5 ? 5 : calculatedSize);
  };
  (0, _react.useEffect)(() => {
    if (elementRef.current && isHintsEnabled) {
      const observer = new MutationObserver(mutations => {
        mutations.forEach(mutation => {
          if (mutation.type === 'attributes' && mutation.attributeName === 'placeholder') {
            setSize(calculateBoxHeight());
          }
        });
      });
      observer.observe(elementRef.current, {
        attributeFilter: ['placeholder']
      });
      return () => observer.disconnect();
    }
  }, [isHintsEnabled]);
  (0, _react.useEffect)(() => {
    setSize(calculateBoxHeight());
  }, [value]);
  (0, _react.useEffect)(() => {
    setIsHintsVisible(isHintsEnabled);
  }, [isHintsEnabled]);
  (0, _react.useEffect)(() => {
    if (isHintsEnabled) {
      if (isHintsVisible && !value) {
        runHints();
      } else {
        hideHints(value || !isHintsEnabled ? placeholderIntl : '');
      }
    } else if (prevIsHintsEnabled) {
      hideHints(placeholderIntl);
    }
  }, [isHintsEnabled, isHintsVisible, value]);
  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)('conversational-search-box-wrapper', {
      fixed: stickySearchBox
    }, {
      absolute: !stickySearchBox
    })
  }, /*#__PURE__*/_react.default.createElement("div", {
    "data-testid": "search-box-div",
    "data-cy": "conversational-search-box-container",
    className: (0, _classnames.default)('search-box-container', {
      'rounded-bottom-border': roundedBottomBorder
    })
  }, /*#__PURE__*/_react.default.createElement("form", {
    onSubmit: onSubmit,
    "data-testid": "search-box-form"
  }, /*#__PURE__*/_react.default.createElement(_textEntry.default, {
    "data-testid": textEntryId,
    id: textEntryId,
    label: "",
    name: "example",
    placeholder: !isHintsEnabled ? placeholderIntl : '',
    className: "search-box-input",
    value: value,
    multiline: true,
    size: size,
    onChange: onChange,
    onKeyDown: handleKeyDown,
    onBlur: () => {
      setIsHintsVisible(true);
    },
    onFocus: () => {
      setIsHintsVisible(false);
    },
    ref: elementRef
  }), /*#__PURE__*/_react.default.createElement(_button.default, {
    "data-testid": "search-box-button",
    icon: icon,
    "aria-label": "Search",
    design: "primary",
    className: (0, _classnames.default)('search-box-button', {
      [aiSearchBoxButtonClassName]: aiSearchBoxButtonClassName
    }),
    size: "default",
    onClick: onSubmit
  }))));
};
exports.AiSearchBox = AiSearchBox;
AiSearchBox.propTypes = {
  icon: _propTypes.default.element,
  placeholder: _propTypes.default.string,
  onChange: _propTypes.default.func.isRequired,
  roundedBottomBorder: _propTypes.default.bool,
  onSubmit: _propTypes.default.func.isRequired,
  value: _propTypes.default.string,
  hintsConfig: _propTypes.default.object,
  stickySearchBox: _propTypes.default.bool,
  aiSearchBoxButtonClassName: _propTypes.default.string
};